<script>
    export default {
        props: {
            id: {
                type: String,
                default: _.uniqueId('textFieldMultiLang')
            },
            name: {
                type: String
            },
            languages: {
                type: Array,
            },
            value: {
                type: Object
            }
        },
        data() {
            return {
                values: {}
            }
        },
        watch: {
            value: {
                immediate: true,
                handler(value) {
                    this.values = value || {};
                }
            },
            values: {
                // immediate: true,
                deep: true,
                handler(value) {
                    this.$emit('input', value);
                }
            }
        }
    }
</script>

<template>
    <div>
        <div class="input-group m-b-xs" v-for="language in languages">
            <div>
                <input v-model="values[language.language_code]" type="text" class="form-control">
            </div>
            <span class="input-group-addon">
            <span class="text-uppercase m-r-xs" v-text="language.language_code"></span>
            <i class="fa fa-language"></i>
        </span>
        </div>
    </div>
</template>
